import { Typography } from '@mui/material'
import s from './TitleWithCount.modules.scss'

export interface TitleWithCountProps {
  title: string
  counter?: number
  showCounterFirst?: boolean
}

const TitleWithCount = (props: TitleWithCountProps) => {
  const { title, counter, showCounterFirst } = props

  return (
    <Typography variant="h6" className={s.titleContainer}>
      {showCounterFirst && (counter || counter === 0) && <span className={s.count}>{counter}</span>}
      <span className={s.title}>{title}</span>
      {!showCounterFirst && (counter || counter === 0) && (
        <span className={s.count}>{counter}</span>
      )}
    </Typography>
  )
}

export default TitleWithCount
